"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useQrCodeEvent = require("./useQrCodeEvent");
Object.keys(_useQrCodeEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useQrCodeEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useQrCodeEvent[key];
    }
  });
});
var _useQrCode = require("./useQrCode");
Object.keys(_useQrCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useQrCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useQrCode[key];
    }
  });
});
var _useShades = require("./useShades");
Object.keys(_useShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useShades[key];
    }
  });
});
var _useGetBackgroundColors = require("./useGetBackgroundColors");
Object.keys(_useGetBackgroundColors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetBackgroundColors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetBackgroundColors[key];
    }
  });
});
var _useGetQrCodeOptions = require("./useGetQrCodeOptions");
Object.keys(_useGetQrCodeOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetQrCodeOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetQrCodeOptions[key];
    }
  });
});
